
import { WhoamiType } from "@/type/user";
import api from "@/util/api";
import { setCookie } from "@/util/cookie";
import customAlert from "@/util/customAlert";
import getCookie from "@/util/getCookie";
import { useTranslations } from "next-intl";
import path from "path";
import { useCallback, useEffect, useState } from "react";

const anonymousUser: WhoamiType = { is_authenticated: false }

export default function useUser() {
    const [user, setUser] = useState<WhoamiType>(anonymousUser)
    const [loading, setLoading] = useState(true)
    
    const [justLoggedOut, setJustLoggedOut] = useState(false) 

    const a = useTranslations("Sentence")

    async function syncPushSubscriptionAfterLogin() {
        // alert("start")

        if (!("serviceWorker" in navigator)) return;
        
        // alert("start in")
        const register = await navigator.serviceWorker.ready;
        const sub = await register.pushManager.getSubscription();
        if (!sub) return; // 구독이 아예 없다면 종료

        
    let input = `/api/push/subscribe/`;
    if (process.env.NODE_ENV === "development") {
        const baseUrl = process.env.NEXT_PUBLIC_API_BASE as string;
        input = baseUrl + input
    }

        await fetch(input, {
            method: "POST",
            credentials: "include", // Django 세션 쿠키 포함
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(sub), // endpoint + keys + user는 서버에서 판단
        });
        console.log(":흰색_확인_표시: 로그인 후 구독 정보 동기화 완료");
    }


    useEffect(() => {

        // 자동 로그인
        api('/api/user/login/', { headers: { 'Content-Type': "application/json" } })
            .then(res => res.json())
            .then(({data, status_code, message}) => {
                if(status_code == 200){
                    login(data.user)
                }
                setLoading(false)
            })
            .catch(() => {
                customAlert(a("CheckYourID&Password"), 'error')
                setLoading(false)
            })
    }, [])

    const login = useCallback((user: WhoamiType) => {
        // alert("login callback")
        syncPushSubscriptionAfterLogin()
        setUser(Object.assign({}, user, { is_authenticated: true }))
    }, [])

    const logout = useCallback((opts: { suppressRedirect?: boolean } = {}) => {
        // api(`/api/user/logout/`, { method: "POST" }).then(() => {
        //     setUser(anonymousUser)
        //     customAlert('로그아웃 되었습니다.', 'success')
        //     if (opts.suppressRedirect) {
        //         setTimeout(() => setJustLoggedOut(false), 0)
        //     }
        // })

        if (opts.suppressRedirect) {
            sessionStorage.setItem('logoutInitiatedByUser', '1')
            setJustLoggedOut(true)
        }

        syncPushSubscriptionAfterLogin();
        return api(`/api/user/logout/`, { method: "POST", skip401: true })
            .then(() => {
                customAlert(a("Logout"), 'success')
                setUser(anonymousUser)
                if (opts.suppressRedirect) {
                    setTimeout(() => {
                        sessionStorage.removeItem('logoutInitiatedByUser')
                        setJustLoggedOut(false)
                    }, 500) 
                }
            })
            
    }, [])

    return { user, loading, setUser, login, logout, justLoggedOut }
}
